import i18n, { i18n_t } from '@/locales/i18n';
// 自定义错误
const CustomErrorCodeMap: Record<string, string> = {
  SyncError: i18n_t('同步失败'),
  DiskSpaceIsFull: i18n_t('磁盘空间已满'),
  NoSuchFileOrDirectory: i18n_t('文件或文件夹不存在'),
  localFileNotFound: i18n_t('本地临时文件被删除，请重试'),
  remoteFileHasChanged: i18n_t('远端文件已被修改'),
  download_check_size_not_match: i18n_t('文件大小不匹配'),
  // 文件同步自定义错误
  SyncTaskExist: i18n_t('同步任务已存在'),
  SameLocalFolderExist: i18n_t('已存在相同本地路径的同步盘'),
  SyncChildFolderExist: i18n_t('本地子目录同步盘已存在'),
  SyncParentFolderExist: i18n_t('本地父目录同步盘已存在'),
  LocalPathNotFound: i18n_t('本地路径不存在'),
  SyncTaskLimit5: i18n_t('当前仅支持创建 5 个同步任务'),
  NoOperatePermission: i18n_t('本地路径无操作权限'),
  SymbolicLinkNotSupported: i18n_t('不支持选择快捷方式'),
  SymbolicLinkOrFileAreNotSupported: i18n_t('当前不支持将文件和快捷方式作为路径，请选择文件夹'),
  NoINoIsNotSupport: i18n_t('不支持当前选择的位置(inode)'),
  AppFileNotSupported: i18n_t('当前不支持选择应用程序'),
  GetAddrInfoError: i18n_t('网络异常, 请检查网络'),
  NotFoundError: i18n_t('本地文件已不存在，请检查后再试'),
  NotReadableError: i18n_t('本地文件读取失败，请检查后再试'),
  // 下载出错
  RiskFileCannotDownload: i18n_t('该文件存在风险，暂不支持下载'),
  NotSupportGroupType: i18n_t('此空间暂不支持同步盘'),
  WorkerNotExist: i18n_t('同步任务不存在'),
  UnknwonLocalSyncId: i18n_t('未能识别此服务'),
  EmptyWorkerId: i18n_t('底层同步进程为空'),
  EmptyIpcHelper: i18n_t('底层通信异常'),
  CmdNotHandledInWorker: i18n_t('同步进程未识别命令'),
  InvalidUserId: i18n_t('未识别用户信息'),
  InvalidOrgId: i18n_t('未识别组织信息'),
  SyncUnavailableWhenLogOut: i18n_t('未登录下同步服务不可用'),
  SyncDataUnavailableWhenLogOut: i18n_t('未登录下同步数据不可用'),
  CreateLocalFolderFailed: i18n_t('本地目录创建失败，请检查权限或更换本地目录'),
  RemoteSyncPathNoPermision: i18n_t('云端同步文件夹缺少上传/下载权限'),
  NotSupportRootDrive: i18n_t('不支持选择盘符'),
  NotSuportFinderAlias: i18n_t('不支持选择替身文件/夹'),
  MaxFileLimitReached: i18n_t('文件数达到上限。请调整规模，或使用同步备份功能重试！'),
  BulkFolderLimitReached: i18n_t('文件数达到上限。请调整规模，或分批次下载！'),
};
export default CustomErrorCodeMap;

export function changeCustomErrorCodeMapLanguage() {
  // eslint-disable-next-line no-restricted-syntax
  for (const item in CustomErrorCodeMap) {
    CustomErrorCodeMap[item] = i18n_t(CustomErrorCodeMap[item]);
  }
}
